const NotFound = () => {
  return <node style={{ width: 1920, height: 1080, color: 0x33c40000 }}></node>;
};

export default NotFound;
